export const DRAWER_WIDTH = 295;

export const LAYER_NAME = {
  default: "Estradas",
  // hydro: "B.Hidrográficas",
  satellite: "Satélite",
};
